import { faBuildingMemo } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';
import { UserJsVm } from '../../shared/generated/Admin/Models/User/JavaScript/UserJsVm';

export const getMainNavRealtors: () => NavRoute = () => {
    const user = getUser();
    return {
        name: 'Realtors'
        , security: sec => !!(sec.coreFeatures && user?.isRealtor)
        , href: 'realtors/appointments/list'
        , icon: faBuildingMemo
        , area: 'realtors'
        , expanded: globalThis.location.href.includes("/realtors/")
        , children: [
            {
                name: 'Appointments'
                , security: sec => !!(sec.coreFeatures && user?.isRealtor)
                , path: 'realtors/appointments/list'
                , activeNavLink: 'realtors/appointments'
                , secondaryNav: [ 'Realtors', 'Appointments' ]
            }
            , {
                name: 'Approvals'
                , security: sec => !!(sec.coreFeatures && user?.isRealtor)
                , path: 'realtors/approvals/list'
                , activeNavLink: 'realtors/approvals'
                , secondaryNav: [ 'Realtors', 'Approvals' ]
            }
        ]
    }
};

function getUser(): UserJsVm | null {
	const userJson: string | null = localStorage.getItem('user') === null 
		? null 
		: localStorage.getItem('user');
	if (userJson !== null) { return JSON.parse(userJson); }
	return null;
}